import React from 'react'
import { useTranslation } from 'react-i18next'
import { MegaTagTitle } from 'components/Elements'
import { ForgotPasswordContainer } from 'features/auth/components'

export const ForgotPassword = () => {
  const { t } = useTranslation()

  return (
    <>
      <MegaTagTitle title={'forgot_password'} />

      <ForgotPasswordContainer />
    </>
  )
}
